export const columns = () => [
  { title: "Name", dataIndex: "name" },
  { title: "Email", dataIndex: "email" },
  { title: "Active", dataIndex: "isActive" },
  { title: "Action", dataIndex: "action" }
];
